import { useMutation, useQueryClient } from '@tanstack/react-query';
import { updateOrderStatus, ordersQueryKeys, type Order } from '@api/orders';

interface UpdateOrderStatusVariables {
  id: number;
  status: 'lead' | 'confirmed' | 'cancelled';
  cancellation_reason?: string;
}

export function useUpdateOrderStatus() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, status, cancellation_reason }: UpdateOrderStatusVariables) =>
      updateOrderStatus(id, status, cancellation_reason),
    onSuccess: (data: Order) => {
      queryClient.invalidateQueries({ queryKey: ordersQueryKeys.detail(data.id) });
      queryClient.invalidateQueries({ queryKey: ordersQueryKeys.lists() });
    },
  });
}
